if (!window.customElements.get('location-reviews')) {
  class LocationReviews extends HTMLElement {
    constructor() {
      super();
      this.amplifyWidget = this.querySelector('[data-amplify-widget]');
      this.reviewStarsButton = this.querySelector('[data-review-stars-button]');
      this.reviewStars = this.querySelector('[data-review-stars]');
      this.reviewRating = this.querySelector('[data-review-rating]');
      this.reviewCount = this.querySelector('[data-review-count]');
    }

    connectedCallback() {
      if (!this.amplifyWidget) { return; }
      this.amplifyObserver();

      if (this.reviewStarsButton) {
        this.reviewStarsButton.addEventListener('click', () => {
          const amplifyButton = this.amplifyWidget.querySelector('[data-test-id="card"]');
          if (!amplifyButton) return;
          amplifyButton.click();
        });
      }
    }

    amplifyObserver() {
      const observer = new MutationObserver(() => {
        this.buildCustomWidget();
        observer.disconnect();
      });

      observer.observe(this.amplifyWidget, {
        childList: true
      });
    }

    buildCustomWidget() {
      const amplifyRating = this.amplifyWidget?.querySelector('[data-rating]')?.getAttribute('data-rating');
      const amplifyReviewCount = this.amplifyWidget?.querySelector('[data-test-id="review-count"]')?.innerText;

      if (!amplifyRating || !amplifyReviewCount || !window.locationReviews?.icons) return;

      if (this.reviewStars) {
        const amplifyRatingInt = parseFloat(amplifyRating);

        for (let i = 1; i <= 5; i++) {
          let star = 'empty'

          if (i <= amplifyRatingInt) {
            star = 'full'
          } else if (i === Math.ceil(amplifyRatingInt)) {
            star = 'half'
          }

          const newElement = document.createElement('div');

          if (star == 'empty') {
            newElement.innerHTML = window.locationReviews.icons.emptyStar;
          } else if (star == 'full') {
            newElement.innerHTML = window.locationReviews.icons.star;
          } else if (star == 'half') {
            newElement.innerHTML = window.locationReviews.icons.halfStar;
          }

          this.reviewStars.appendChild(newElement);
        }

        this.reviewStarsButton.classList.remove('invisible');
      }

      if (this.reviewRating) {
        this.reviewRating.innerText = parseFloat(amplifyRating).toFixed(1);
      }

      if (this.reviewCount) {
        this.reviewCount.innerText = amplifyReviewCount;
      }
    }
  }

  window.customElements.define('location-reviews', LocationReviews);
}